<script setup lang="ts">
import { inject, watch } from "vue";
import { APP } from "@/stores/app";
import { useFullscreen } from "@vueuse/core";

const appStore = inject(APP)!;

watch(
  () => appStore?.instance,
  () => {
    const { isSupported, isFullscreen, enter, exit } = useFullscreen(appStore?.instance);

    appStore.isFullscreenSupported = isSupported.value;
    appStore.isFullscreenActive = isFullscreen.value;
    appStore.enterFullscreen = enter;
    appStore.exitFullscreen = exit;
  }
);
</script>

<template>
  <div
    :class="{
      'deck-fullscreen-content-active':
        appStore?.isFullscreenActive && appStore?.isFullscreenSupported,
      'deck-fullscreen-content-inactive': !appStore?.isFullscreenActive
    }"
  >
    <slot></slot>
  </div>
</template>

<style scoped>
.deck-fullscreen-content-active {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  margin: auto;
  aspect-ratio: 16/9;
  width: calc(100dvh * 16 / 9);
  max-width: 100%;
}

.deck-fullscreen-content-inactive {
  height: 100%;
}
</style>
